// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"q_bg","slideTop":"q_bh"};